import { FormControlLabel, Grid, Radio, Typography } from '@mui/material';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import {
  selectPhaseData,
  selectUpdatedPhaseData,
  updatePhaseData
} from './phasesSlice';
import { useDispatch, useSelector } from 'react-redux';

export const PhaseModalLine = ({ phaseId }) => {
  const currentPhaseData = useSelector(selectPhaseData(phaseId));
  const updatedPhaseData = useSelector(selectUpdatedPhaseData(phaseId));
  const dispatch = useDispatch();

  const parseDate = (raw) => {
    const d = raw ? dayjs(raw) : null;
    return d?.isValid() ? d : null;
  };
  const estimatedValue = parseDate(
    updatedPhaseData?.estimatedCompletionDate ??
      currentPhaseData?.estimatedCompletionDate
  );
  const actualValue = parseDate(
    updatedPhaseData?.actualCompletionDate ??
      currentPhaseData?.actualCompletionDate
  );

  const handleEstimatedDateChange = (_updatedDate, estimatedCompletionDate) => {
    if (estimatedCompletionDate) {
      dispatch(
        updatePhaseData({
          phaseId,
          estimatedCompletionDate
        })
      );
    }
  };
  const handleActualDateChange = (_updatedDate, actualCompletionDate) => {
    if (actualCompletionDate) {
      dispatch(updatePhaseData({ phaseId, actualCompletionDate }));
    }
  };
  const PhaseLabel = () => {
    return <Typography variant="bodyMedium">Phase {phaseId}</Typography>;
  };

  return (
    <Grid container sx={{ alignItems: 'center' }} gap={1}>
      <Grid size={2}>
        <FormControlLabel
          control={<Radio />}
          label={<PhaseLabel />}
          value={phaseId}
        />
      </Grid>
      <Grid size={4.75} data-testid={`estimatedCompletionDate${phaseId}`}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MuiDatePicker
            value={estimatedValue}
            onChange={(next) =>
              handleEstimatedDateChange(
                next,
                next?.isValid() ? next.format('DD-MMM-YYYY') : null
              )
            }
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: 'MM/DD/YYYY',
                id: `estimatedCompletionDate${phaseId}`
              }
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid size={4.75} data-testid={`actualCompletionDate${phaseId}`}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MuiDatePicker
            value={actualValue}
            onChange={(next) =>
              handleActualDateChange(
                next,
                next?.isValid() ? next.format('DD-MMM-YYYY') : null
              )
            }
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: 'MM/DD/YYYY',
                id: `actualCompletionDate${phaseId}`
              }
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};
